import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import styles from './confirmDetachChild.module.scss'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { Close, Delete } from '@mui/icons-material'
import { useMutation } from '@apollo/client'
import { DETACH_CHILD_ASSMAT } from '@/modules/API/parent/assmatHandler'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface InfoChildDialogProps {
    open: boolean
    handleClose: () => void
    childName: string
    childId: number
    getParentInfos: () => void
}

const ConfirmDetachChild: FunctionComponent<InfoChildDialogProps> = ({
    open,
    handleClose,
    childName,
    childId,
    getParentInfos
}: InfoChildDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [removeChild] = useMutation(DETACH_CHILD_ASSMAT, {
        variables: {
            childId: childId
        },
        onCompleted: () => {
            getParentInfos()
            showNotificationSuccess(t('childDeleted'))
            handleClose()
        },
        onError: () => {
            showNotificationError(t('errorDeletedChild'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('detachChild')} parent />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('detachChildMessage')}</p>
                <p className={styles.TextChild}>{childName}</p>
                <p className={styles.Text}>{t('noRollBack')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={removeChild}
                        className={styles.Button}
                        parent
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                        parent
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ConfirmDetachChild
